<template lang="pug">
  .c-media.c-comments__media
    .c-media__left
      vue-avatar-icon.c-comments__avatar(:user="comment.user")

    .c-media__body.c-comments__body
      ul.c-comments__metalist
        li
          a.u-block(:href='userMyPage', target='_parent', v-if='userMyPage', rel='nofollow')
            span.c-comments__author.u-text-overflow-1(:class="{ 'c-comments__author--staff' : isStaff }", v-text='userName', :title='userName')
              //- Safari-10.0.1 requires ZWSP for splitting text in ul elements
            | &#8203;
          div(v-else)
            span.c-comments__author.u-text-overflow-1(:class="{ 'c-comments__author--staff' : isStaff }", v-text='userName', :title='userName')
              //- Safari-10.0.1 requires ZWSP for splitting text in ul elements
            | &#8203;
        li(v-if='isBacker && !isStaff')
          span.c-label.c-label--default.c-label--sm(v-text='purchasedText')
        li(v-if='isStaff')
          img.img-responsive.img-responsive--center(:src='"/static/common/icons/tom_security.svg" | cloudImageUrl', alt="TOM Staff", style="width: 1.25em;")
        li
          time.c-comments__time(:datetime="comment.comment_at", v-text='formattedCommentedAt')

      p.c-comments__comment(v-html='filteredComment', :class="{ 'c-comments__comment--emoji-only': isEmojiOnly }")

      p.c-label.c-label--default.c-label--sm(v-if='comment.deleted_at')
        | Comment was deleted due to violation of discussion guidelines.

      .c-comments__actions
        a(href='#', @click.prevent='clickReply')
          i.icon-comment-alt.u-mrxs
          | {{__("Reply")}}

      .c-comments__menu(v-if="isLogin && !comment.deleted_at")
        .c-dropdown.c-dropdown--right.c-dropdown--thin
          button.c-btn.c-btn--sm.c-btn--inconspicuous.u-color-muted(data-toggle="dropdown", aria-expanded="false"): i.icon-chevron-down
          ul.c-dropdown__menu.c-menu.c-menu--vertical
            li(v-if='!isAuthor'): a(href='#' @click.prevent='clickReport') {{__("Report to TOM")}}
            li(v-if='!isAuthor'): a(href='#' @click.prevent='clickMarkAsSpam') {{__("Mark as Spam")}}
            li(v-if='isAuthor'): a(href='#' @click.prevent='clickEdit') {{__("Edit")}}
            li(v-if='isAuthor'): a(href='#' @click.prevent='clickDelete') {{__("Delete")}}

    //- Report to TOM
    vue-user-comment-form(ref='reportForm', type='report', v-show='status === "report"', :placeholder='__("Report to TOM...")', :rows='3', :buttons='{submit: {value: __("Report")}, cancel: {value: __("Cancel")}}')
    //- Edit comment
    vue-user-comment-form(ref='editForm', type='edit', v-show='status === "edit"', :value='comment.comment', :placeholder='__("Edit comments...")', :rows='3', :buttons='{submit: {value: __("Save")}, cancel: {value: __("Cancel")}}')
</template>

<script>
const COMMENT_STATUS = {
  INIT: 'init',
  EDIT: 'edit',
  REPORT: 'report'
};

import { userCommentsStore } from '../../stores/UserComments';
import { I18n } from '../../util/mixin/i18n.mixin';

import textUtil from '../../util/text';
import emojiUtil from '../../util/emoji';
import urlUtil from '../../util/url';
import avatarIcon from '../avatar/avatarIcon.vue';
import userCommentForm from './userCommentForm.vue';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default {
  mixins: [I18n],

  filters: {
    cloudImageUrl: urlUtil.cloudImageUrl
  },

  components: {
    'vue-avatar-icon': avatarIcon,
    'vue-user-comment-form': userCommentForm
  },
  props: ['comment'],

  data() {
    return { status: COMMENT_STATUS.INIT };
  },

  computed: {
    user() {
      return userCommentsStore.getUserInfo();
    },
    isLogin() {
      return userCommentsStore.isUserLogin();
    },
    canPost() {
      return userCommentsStore.canPost();
    },

    isStaff() {
      return this.comment.flags.staff;
    },

    isBacker() {
      return this.comment.flags.backer;
    },

    isAuthor() {
      return this.user && this.comment.user._id === this.user._id;
    },

    isParent() {
      return !this.comment.reply_to;
    },

    purchasedText() {
      return this.__('Backer');
    },

    staffText() {
      return this.__('TOM Staff');
    },

    formattedCommentedAt() {
      return dayjs(this.comment.comment_at).fromNow();
    },

    isEmojiOnly() {
      return /^(:[a-zA-Z0-9-_+]+:\s*)+$/.test(this.comment.comment);
    },

    filteredComment() {
      return emojiUtil.emojiColon2img(
        textUtil.nl2br(textUtil.escape(this.comment.comment))
      );
    },

    userName() {
      if (this.comment.user && this.comment.user.name) {
        return this.comment.user.name;
      }
      return this.__('Account Deleted');
    },

    userMyPage() {
      if (this.comment.user && this.comment.user.name) {
        const pathname = this.comment.user.user_name || this.comment.user._id;
        return `/${pathname}`;
      }
      return '';
    }
  },

  created() {
    this.$root.$on('UPDATED', () => {
      this.resetStatus();
      return true;
    });
  },

  mounted() {
    // レポートフォームを閉じる
    this.$refs.reportForm.$on('cancel', () => {
      this.resetStatus();
    });

    // レポートを送信
    this.$refs.reportForm.$on('submit', () => {
      userCommentsStore.postReport(
        this.comment._id,
        this.$refs.reportForm.comment
      );
    });

    // 編集コメントフォームを閉じる
    this.$refs.editForm.$on('cancel', () => {
      this.resetStatus();
    });

    // 編集コメントを送信
    this.$refs.editForm.$on('submit', (options) => {
      userCommentsStore.postEditComment(
        this.comment._id,
        this.$refs.editForm.comment,
        options
      );
    });
  },

  methods: {
    resetStatus() {
      this.status = COMMENT_STATUS.INIT;
      // cancel・editボタンの有無で高さが変化するので親に伝える
      if (window.vueEventBus && window.vueEventBus.userComments) {
        window.vueEventBus.userComments.$emit('CHANGE_HEIGHT');
      }
    },

    clickReply() {
      this.$parent.$emit('status.reply', true);
      this.resetStatus();
    },

    clickReport() {
      this.status =
        this.status === COMMENT_STATUS.REPORT
          ? COMMENT_STATUS.INIT
          : COMMENT_STATUS.REPORT;
      this.resetReplyStatus();
      this.$nextTick(function () {
        this.$refs.reportForm.focus();
      });
    },

    clickMarkAsSpam() {
      if (window.confirm(this.__('Report this comment as spam?'))) {
        userCommentsStore.postMarkAsSpam(this.comment._id);
      }
    },

    clickEdit() {
      this.status =
        this.status === COMMENT_STATUS.EDIT
          ? COMMENT_STATUS.INIT
          : COMMENT_STATUS.EDIT;
      this.resetReplyStatus();
      this.$nextTick(function () {
        this.$refs.editForm.focus();
      });
    },

    clickDelete() {
      if (window.confirm(this.__('Delete this comment?'))) {
        userCommentsStore.deleteComment(this.comment._id);
      }
    },

    resetReplyStatus() {
      this.$parent.$emit('status.reply', false);
    }
  }
};
</script>
